var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OuterCasing',{staticClass:"main user-select",staticStyle:{"max-width":"450px","margin":"0 auto","position":"inherit"},attrs:{"isScroll":_vm.isScroll}},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }